import { Component, Input } from '@angular/core';
import { TrackingKeywordSuggestion, KeywordResearchTypes, KeywordSuggestionSources, PageSuggestion, PageSuggestionSources } from '../../../../shared/models/keywords/keywords';

@Component({
  selector: 'app-components-shared-keyword-research-tracking-keyword',
  templateUrl: './tracking-keyword.component.html',
  styleUrls: ['../keyword-research/keyword-research.component.scss']
})
export class TrackingKeywordComponent {
  @Input() keywordResearchType: KeywordResearchTypes;
  @Input() customer: Boo.Objects.Customer;
  @Input() pageSuggestions: PageSuggestion[];
  @Input() trackingKeywordSuggestion: TrackingKeywordSuggestion;
  @Input() trackingKeywordSuggestions: TrackingKeywordSuggestion[];

  removeKeyword() {
    if (this.trackingKeywordSuggestion.SourceId === KeywordSuggestionSources.User && this.trackingKeywordSuggestion.TrackingKeywordSuggestionId === 0) {
      this.trackingKeywordSuggestions.splice(this.trackingKeywordSuggestions.indexOf(this.trackingKeywordSuggestion), 1);
    } else {
      this.trackingKeywordSuggestion.IsSelected = false;
      this.trackingKeywordSuggestion.IsModified = true;
    }
  }

  get validationMessage(): { error: string; details?: string } {
    switch(this.keywordResearchType) {
      case KeywordResearchTypes.SeoOnboarding:
        return this.getOnboardingValidationMessage();
      case KeywordResearchTypes.StrategyUpdate:
        return this.getStrategyUpdateValidationMessage();
      default:
        return null;
    }
  }

  private getOnboardingValidationMessage(): { error: string; details?: string } {
    const keywordPhrases = this.pageSuggestions.filter(x => x.IsSelected && x.IsCampaignNational === this.customer.IsCampaignNational)
    .flatMap(c => c.KeywordSuggestions)
    .filter(x => x.IsSelected)
    .map(x => x.KeywordPhrase.toLowerCase().trim())
    .concat(this.trackingKeywordSuggestions.filter(x => x.IsSelected && x.IsCampaignNational === this.customer.IsCampaignNational && x != this.trackingKeywordSuggestion).map(x => x.KeywordPhrase.toLowerCase().trim()));

    if (keywordPhrases.includes(this.trackingKeywordSuggestion.KeywordPhrase.toLowerCase().trim())) {
      return { error: 'Duplicate' };
    }
    return null;
  }
  
  private getStrategyUpdateValidationMessage(): { error: string; details?: string } {
    const keywordPhrases = this.pageSuggestions.filter(x => (x.SourceId === PageSuggestionSources.CustomerCampaign || x.IsSelected) && x.IsCampaignNational === this.customer.IsCampaignNational)
      .flatMap(x => 
        x.KeywordSuggestions
          .filter(y => y.IsSelected)
          .map(y => ({ 
            keywordPhrase: y.KeywordPhrase.toLowerCase().trim(),
            source: x.Url })))
      .concat(
        this.trackingKeywordSuggestions.filter(x => x != this.trackingKeywordSuggestion && x.IsSelected && x.IsCampaignNational === this.customer.IsCampaignNational)
        .map(x => ({ 
          keywordPhrase: x.KeywordPhrase.toLowerCase().trim(),
          source: 'Tracking' })));

    const matches = keywordPhrases.filter(x => x.keywordPhrase === this.trackingKeywordSuggestion.KeywordPhrase.toLowerCase().trim()).map(x => x.source);

    if (matches.length > 0) {
      return { error: 'Duplicate', details: matches.join('<br>') }
    }

    return null
  }
}
